import defaultLayout from "@/layouts/side-nav-outer-toolbar";
import loadView from "../common/loadView";

export default [
  {
    path: "/phone/:mode/:id?",
    name: "phone",
    meta: {
      requiresAuth: true,
      requiresPermission: true,
      layout: defaultLayout,
      navPermission: "Марка авто"
    },
    component: loadView("phone-numbers/phone-number-detail-view"),
  },
  {
    path: "/phones",
    name: "phones",
    meta: {
      requiresAuth: true,
      requiresPermission: true,
      layout: defaultLayout,
      navPermission: "Марка авто"
    },
    component: loadView("phone-numbers/phone-numbers-list-view"),
  },
];
